<template>
  <div class="home-page">
    <div class="currency">
      <div class="top-left" id="top-left" :style="{ height: HEIGHT1 + 'px' }">
        <income-chart v-bind:HEIGHT1="HEIGHT1"></income-chart>
        <income-indicators-chart></income-indicators-chart>
      </div>
      <div
        class="top-center"
        id="top-center"
        :style="{ height: HEIGHT1 + 'px' }"
      >
        <map-chart></map-chart>
      </div>
      <div class="top-right" :style="{ height: HEIGHT1 + 'px' }">
        <current-charging-chart
          v-bind:HEIGHT1="HEIGHT1"
        ></current-charging-chart>
        <ranking-chart></ranking-chart>
      </div>
      <div
        class="bottom-left"
        :style="{ height: HEIGHT2 + 'px', marginTop: mtheight + 'px' }"
      >
        <number-chart></number-chart>
      </div>
      <div
        class="bottom-center"
        id="bottom-center"
        :style="{ height: HEIGHT2 + 'px', marginTop: mtheight + 'px' }"
      >
        <electric-quantity-chart></electric-quantity-chart>
      </div>
      <div
        class="bottom-right"
        :style="{ height: HEIGHT2 + 'px', marginTop: mtheight + 'px' }"
      >
        <alarm-type></alarm-type>
      </div>
      <div style="clear: both"></div>
    </div>
    <!-- 大屏适配 -->
    <div class="display-screen clearfix">
      <div class="top-left" id="top-left">
        <div class="tl-first-child" :class="[active == true ? 'active' : '']">
          <income-chartt></income-chartt>
        </div>
        <div class="tl-second-child" :class="[active == true ? 'active' : '']">
          <income-indicators-chartt></income-indicators-chartt>
        </div>
      </div>
      <div class="top-right clearfix">
        <div class="tr-first-child" :class="[active == true ? 'active' : '']">
          <current-charging-chartt></current-charging-chartt>
        </div>
        <div class="tr-second-child" :class="[active == true ? 'active' : '']">
          <ranking-chartt></ranking-chartt>
        </div>
      </div>
      <div
        class="top-center"
        id="top-center"
        :class="[active == true ? 'active' : '']"
      >
        <map-chartt></map-chartt>
      </div>
      <div class="bottom-right clearfix">
        <div class="br-first-child" :class="[active == true ? 'active' : '']">
          <electric-quantity-chartt></electric-quantity-chartt>
        </div>
        <div>
          <div
            class="br-second-child"
            :class="[active == true ? 'active' : '']"
          >
            <number-chartt></number-chartt>
          </div>
          <div class="br-third-child" :class="[active == true ? 'active' : '']">
            <alarm-typet></alarm-typet>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChargingModeChart from "./chargingModeChart.vue";
import CurrentChargingChart from "./currentChargingChart.vue";
import ElectricQuantityChart from "./electricQuantityChart.vue";
import IncomeChart from "./incomeChart.vue";
import IncomeIndicatorsChart from "./incomeIndicatorsChart.vue";
// import IncomeRatioChart from "./incomeRatioChart.vue"
import MapChart from "./mapChart.vue";
import NumberChart from "./numberChart.vue";
import RankingChart from "./rankingChart.vue";
import AlarmType from "./alarmType.vue";

import ChargingModeChartt from "./displayScreen/chargingModeChart";
import CurrentChargingChartt from "./displayScreen/currentChargingChart.vue";
import ElectricQuantityChartt from "./displayScreen/electricQuantityChart.vue";
import IncomeChartt from "./displayScreen/incomeChart.vue";
import IncomeIndicatorsChartt from "./displayScreen/incomeIndicatorsChart.vue";
import MapChartt from "./displayScreen/mapChart.vue";
import NumberChartt from "./displayScreen/numberChart.vue";
import RankingChartt from "./displayScreen/rankingChart.vue";
import AlarmTypet from "./displayScreen/alarmType.vue";

export default {
  data() {
    return {
      HEIGHT1: "",
      width: "",
      HEIGHT2: "",
      width2: "",
      mlwidth: "",
      mtheight: "",
      active: false,
    };
  },
  computed: {
    isChangeMsg() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    isChangeMsg(val) {
      if (val == false) {
        this.active = true;
      } else {
        this.active = false;
      }
    },
  },
  mounted() {
    let o = document.getElementById("top-center");
    this.width = o.clientWidth || o.offsetWidth;
    // debugger
    // this.HEIGHT = this.width/1.349;
    // this.HEIGHT = this.width/1.3450;
    this.HEIGHT1 = this.width / 1.53001;
    let o2 = document.getElementById("bottom-center");
    this.width2 = o2.clientWidth || o2.offsetWidth;
    // debugger
    this.HEIGHT2 = this.width2 / 3.1498;

    let tl = document.getElementById("top-left");
    // debugger
    this.mlwidth = tl.clientWidth || tl.offsetWidth;
    this.mtheight = this.mlwidth / 24.5;
    // console.log(this.mtheight);
    // const that = this;
    // window.addEventListener("resize", function() {
    //   return (() => {
    //     let o = document.getElementById("top-center");
    //     that.width = o.clientWidth||o.offsetWidth;
    //     // debugger
    //     // this.HEIGHT = this.width/1.349;
    //     // this.HEIGHT = this.width/1.3450;
    //     that.HEIGHT = that.width/1.53001;

    //     let o2 = document.getElementById("bottom-center");
    //     that.width2 = o2.clientWidth||o2.offsetWidth;
    //     // debugger
    //     that.HEIGHT2 = that.width2/3.1498;

    //     let tl = document.getElementById("top-left");
    //     // debugger
    //     that.mlwidth = tl.clientWidth||tl.offsetWidth;
    //     that.mtheight = that.mlwidth / 24.5;
    //   })();
    // });
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
  components: {
    // 将只在父组件模板中可用
    ChargingModeChart,
    CurrentChargingChart,
    ElectricQuantityChart,
    IncomeChart,
    IncomeIndicatorsChart,
    // IncomeRatioChart,
    MapChart,
    NumberChart,
    RankingChart,
    AlarmType,

    ChargingModeChartt,
    CurrentChargingChartt,
    ElectricQuantityChartt,
    IncomeChartt,
    IncomeIndicatorsChartt,
    MapChartt,
    NumberChartt,
    RankingChartt,
    AlarmTypet,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home-page {
  // padding-top: 16px;
  // min-width: 900px;
  height: auto;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  -o-user-select: none;
  user-select: none;
  .currency {
    display: block;
    .top-left {
      width: 24.5%;
      // width: 24%;
      float: left;
      margin-right: 1%;
      margin-left: 1%;
      position: relative;
    }
    .top-left {
      // min-width: 360px;
    }
    .top-center {
      width: 47%;
      // height: 596px;
      background: url(../../assets/img/Frame_02.png) no-repeat;
      background-size: 100% 100%;
      float: left;
      overflow: hidden;
    }
    .top-right {
      width: 24.5%;
      // width: 24%;
      float: left;
      margin-left: 1%;
      margin-right: 1%;
    }
    .bottom-left {
      width: 24.5%;
      // width: 24%;
      float: left;
      margin-left: 1%;
    }
    .bottom-center {
      width: 47%;
      // height: 290px;
      float: left;
      // margin-bottom: 16px;
      background: url(../../assets/img/Frame_01.png) no-repeat;
      background-size: 100% 100%;
      margin-left: 1%;
      .line {
        // display: inline-block;
        width: 1px;
        height: 226px;
        float: left;
        margin-top: 40px;
        background: url(../../assets/img/line.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    .bottom-right {
      width: 24.5%;
      // width: 24%;
      float: left;
      margin-left: 1%;
      margin-right: 1%;
    }
  }
  .display-screen {
    display: none;
    .top-left {
      margin-left: 20px;
      float: left;
      .tl-first-child {
        // width: 360px;
        // height: 319px;
        width: 424px;
        height: 343px;
        background: url(../../assets/img/Frame.png) no-repeat;
        background-size: 100% 100%;
        margin-top: 20px;
      }
      .tl-first-child.active {
        // width: 340px;
        width: 404px;
      }
      .tl-second-child {
        // width: 360px;
        // height: 319px;
        width: 424px;
        height: 343px;
        background: url(../../assets/img/Frame_03.png) no-repeat;
        background-size: 100% 100%;
        margin-top: 20px;
      }
      .tl-second-child.active {
        // width: 340px;
        width: 404px;
      }
    }
    .top-center {
      float: left;
      width: 710px;
      // height: 659px;
      // width: 966px;
      height: 707px;
      background: url(../../assets/img/Frame_02.png) no-repeat;
      background-size: 100% 100%;
      overflow: hidden;
      margin-top: 20px;
      margin-left: 20px;
    }
    .top-center.active {
      width: 680px;
      // width: 936px;
    }
    .top-right {
      float: left;
      margin-top: 20px;
      margin-left: 20px;
      .tr-first-child {
        // width: 360px;
        // height: 319px;
        width: 424px;
        height: 343px;
        background: url(../../assets/img/Frame.png) no-repeat;
        background-size: 100% 100%;
      }
      .tr-first-child.active {
        // width: 340px;
        width: 404px;
      }
      .tr-second-child {
        // width: 360px;
        // height: 319px;
        height: 343px;
        width: 424px;
        background: url(../../assets/img/Frame_03.png) no-repeat;
        background-size: 100% 100%;
        margin-top: 20px;
      }
      .tr-second-child.active {
        // width: 340px;
        width: 404px;
      }
    }
    .bottom-right {
      float: left;
      margin-top: 20px;
      margin-left: 20px;
      .br-first-child {
        // width: 710px;
        // height: 319px;
        width: 838px;
        height: 343px;
        background: url(../../assets/img/Frame.png) no-repeat;
        background-size: 100% 100%;
      }
      .br-first-child.active {
        // width: 680px;
        width: 818px;
      }
      .br-second-child {
        // width: 345px;
        // height: 319px;
        width: 409px;
        height: 343px;
        background: url(../../assets/img/Frame.png) no-repeat;
        background-size: 100% 100%;
        float: left;
        margin-top: 20px;
      }
      .br-second-child.active {
        // width: 330px;
        width: 394px;
      }
      .br-third-child {
        // width: 345px;
        // height: 319px;
        width: 409px;
        height: 343px;
        background: url(../../assets/img/Frame.png) no-repeat;
        background-size: 100% 100%;
        float: left;
        margin-left: 20px;
        margin-top: 20px;
      }
      .br-third-child.active {
        // width: 330px;
        width: 394px;
      }
    }
  }
}
@media screen and (width: 2560px) and (height: 816px) {
  .home-page {
    .currency {
      display: none;
    }
    .display-screen {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/homePage.vue